import { ChainId } from '@dcl/schemas';
export const CROSS_CHAIN_SUPPORTED_CHAINS = [
    ChainId.MATIC_MUMBAI,
    ChainId.ETHEREUM_SEPOLIA,
    ChainId.ETHEREUM_MAINNET,
    ChainId.MATIC_MAINNET
];
//# sourceMappingURL=types.js.map